import { Controller, useForm } from 'react-hook-form'
import * as S from './styles'
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useAdditionalInfoSchema } from 'pages/Checkin/schemas/AdditionalInfo';
import { DropdownWithError } from 'components/DropdownWithError';
import { t } from 'i18next';
import { RadioButton } from 'components/RadioButton';
import { Input } from 'components/Input';
import { Link, useNavigate } from 'react-router-dom';
import { FooterWithButtons } from 'pages/Checkin/components/FooterWithButtons';
import { useSessionStorage } from 'context/sessionStorage';
import fetchAxios from 'services/http';
import { useCheckin } from 'pages/Checkin/hook/useCheckin';
import { useEffect, useState } from 'react';
import { useGetFileFromSessionStorage } from 'pages/Checkin/hook/useGetFileFromSessionStorage';
import axios from 'axios';

export const AdditionalInfo = () => {
    const { accompanying, checkinDetails, arrivelAndDepartureHours, address, guestCheckinData } = useCheckin()
    const [selfieFile, setSelfieFile] = useState<File | null>(null)
    const [frontFile, setFrontFile] = useState<File | null>(null)
    const [backFile, setBackFile] = useState<File | null>(null)

    const { saveToSessionStorage, getFromSessionStorage } = useSessionStorage()

    const getFileFromSessionStorage = useGetFileFromSessionStorage();

    const navigate = useNavigate();

    useEffect(() => {

        const selfieFileName = "selfie";
        const frontFileName = "front";
        const backFileName = "back";
        getFileFromSessionStorage(selfieFileName, selfieFileName).then(file => {
            if (file) {
                console.log(file, 'file')
                setSelfieFile(file);
            }
        });
        getFileFromSessionStorage(frontFileName, frontFileName).then(file => {
            if (file) {
                setFrontFile(file);
            }
        });
        getFileFromSessionStorage(backFileName, backFileName).then(file => {
            if (file) {
                setBackFile(file);
            }
        });
    }, [getFileFromSessionStorage])

    const schema = useAdditionalInfoSchema();

    type FormData = z.infer<typeof schema>;

    const { handleSubmit, formState: { errors }, setValue, control, trigger, watch } = useForm<FormData>({
        resolver: zodResolver(schema),
    });

    console.log(address, 'address')

    const pathnameActual: string = window.location.pathname.endsWith('/') ? window.location.pathname.slice(0, -1) : window.location.pathname.slice(0, window.location.pathname.lastIndexOf('/'));

    const arrayOptionReasonForTravel = [
        { value: t('checkin.additionalInformation.forms.select.options.business'), label: t('checkin.additionalInformation.forms.select.options.business') },
        { value: t('checkin.additionalInformation.forms.select.options.tourism'), label: t('checkin.additionalInformation.forms.select.options.tourism') },
        { value: t('checkin.additionalInformation.forms.select.options.studies'), label: t('checkin.additionalInformation.forms.select.options.studies') },
        { value: t('checkin.additionalInformation.forms.select.options.other'), label: t('checkin.additionalInformation.forms.select.options.other') },
    ]

    const arrayOptionHowFindYogha = [
        { value: t('checkin.additionalInformation.forms.select.options.airbnb'), label: t('checkin.additionalInformation.forms.select.options.airbnb') },
        { value: t('checkin.additionalInformation.forms.select.options.google'), label: t('checkin.additionalInformation.forms.select.options.google') },
        { value: t('checkin.additionalInformation.forms.select.options.referals'), label: t('checkin.additionalInformation.forms.select.options.referals') },
        { value: t('checkin.additionalInformation.forms.select.options.socialNetworks'), label: t('checkin.additionalInformation.forms.select.options.socialNetworks') },
        { value: t('checkin.additionalInformation.forms.select.options.other'), label: t('checkin.additionalInformation.forms.select.options.other') },
    ]

    const translateAnwser = (anwser: string) => {
        switch (anwser) {
            case 'Business':
                return 'Negócios'
            case 'Tourism':
                return 'Turismo'
            case 'Studies':
                return 'Estudo'
            case 'Other':
                return 'Outros'
            case 'Airbnb':
                return 'Portal Airbnb'
            case 'Referals':
                return 'Indicação'
            case 'Social Networks':
                return 'Redes sociais'
            case 'Google':
                return 'Google'
            default:
                return anwser
        }
    }

    async function uploadFile(file: File | null, id: any, type: 'back' | 'front' | 'selfie') {
        if (!file) {
            return;
        }
        console.log('Fazendo upload do arquivo:', file)
        const formData = new FormData();

        const typeFile = '.' + file.type.split('/')[1];

        formData.append("image", file, file.name + typeFile); // "file" é o nome do campo na API

        try {
            const response = await fetchAxios.post(`/checkin/image/${id}/${type}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            console.log('Upload bem sucedido:', response.data);
        } catch (error) {
            if (axios.isAxiosError(error)) {
                console.error('Erro ao fazer upload do arquivo:', error.response?.data);
            } else {
                console.error('Erro desconhecido:', error);
            }
        }
    }

    const onSubmit = async (data: FormData) => {
        saveToSessionStorage('additional-info', data)
        try {
            const resSelfie = await uploadFile(selfieFile, checkinDetails.customer_id, 'selfie')
            console.log(resSelfie, 'resSelfie')
        } catch (error) {

        }
        try {
            const resFront = await uploadFile(frontFile, checkinDetails.customer_id, 'front')
            console.log(resFront, 'resFront')
        } catch (error) {

        }
        try {
            const resBack = await uploadFile(backFile, checkinDetails.customer_id, 'back')
            console.log(resBack, 'resBack')
        } catch (error) {

        }

        if (accompanying.length > 0) {
            try {
                const res = await fetchAxios.post(`/checkin/escorts`, {
                    data: accompanying
                })
                console.log(res, 'res')
            } catch (error) {

            }
        }
        console.log(guestCheckinData, 'guestdata')
        try {
            const res = await fetchAxios.post('/checkin/create', {
                city_origin: data.originCity,
                booking_id: checkinDetails.booking_id,
                question_yogha: translateAnwser(data.howToFindYogha.value),
                question_reason_trip: translateAnwser(data.reasonToTrip.value),
                question_curitiba: data.knownTheCity,
                arrival_time: arrivelAndDepartureHours.arrival_time,
                checkout_time: arrivelAndDepartureHours.checkout_time,
                ...address,
                ...guestCheckinData
            })
            console.log(res, 'res')
            navigate(`${pathnameActual}/successful`)
        } catch (error) {

        }
    }

    const handleBackPage = () => {
        navigate(`${pathnameActual}/arrival-and-departure`)
    }

    return (
        <S.ContainerAdditionalInfo>
            <h5>
                {t('checkin.additionalInformation.title')}
            </h5>
            <S.FormContainer>
                <Controller
                    name={'reasonToTrip'}
                    control={control}
                    render={({ field }) => (
                        <DropdownWithError label={t('checkin.additionalInformation.forms.label.reasonOfTheTrip')} name="reasonToTrip" value={field.value} onChange={(option) => option ? field.onChange(option) : field.onChange(undefined)}
                            placeholder={t('checkin.personalInformation.forms.placeholder.countryYouLive')} options={arrayOptionReasonForTravel} widthDrop={'calc(100% - 16px)'} errorText={errors.reasonToTrip?.message} />
                    )}
                />
                <Controller
                    name="originCity"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                        <Input width={"100%"} id="originCity" onBlur={() => trigger('originCity')} htmlFor="originCity" errorText={errors.originCity?.message} onChange={onChange} placeholder={''} title={t('checkin.additionalInformation.forms.label.cityOfOrigin')} value={value} />
                    )
                    }
                />
                <Controller
                    name={'howToFindYogha'}
                    control={control}
                    render={({ field }) => (
                        <DropdownWithError label={t('checkin.additionalInformation.forms.label.howDidYouFindYogha')} name="howToFindYogha" value={field.value} onChange={(option) => option ? field.onChange(option) : field.onChange(undefined)}
                            placeholder={t('checkin.personalInformation.forms.placeholder.countryYouLive')} options={arrayOptionHowFindYogha} widthDrop={'calc(100% - 16px)'} errorText={errors.howToFindYogha?.message} />
                    )}
                />

                <S.ContainerOptionsRadioButton>
                    <strong>{t('checkin.additionalInformation.forms.label.didYouVisitTheCityBefore')}</strong>
                    <S.ContainerRadioButtons >
                        <Controller
                            name="knownTheCity"
                            control={control}
                            render={({ field }) => (
                                <RadioButton {...field} control={control} label={t('checkin.additionalInformation.forms.label.optionYes')} value="Sim" />
                            )
                            }
                        />
                        <Controller
                            name="knownTheCity"
                            control={control}
                            render={({ field }) => (
                                <RadioButton {...field} control={control} label={t('checkin.additionalInformation.forms.label.optionNo')} value="Não" />
                            )
                            }
                        />
                    </S.ContainerRadioButtons>
                </S.ContainerOptionsRadioButton>
            </S.FormContainer>
            <S.ContainerTermAndConditions>
                <p>{t('checkin.additionalInformation.termsAndConditions')} <Link to='/termos-e-condicoes/' >{t('checkin.additionalInformation.linkTermsAndConditions')}</Link></p>
            </S.ContainerTermAndConditions>
            <FooterWithButtons handleBackStep={handleBackPage} handleNextStep={handleSubmit(onSubmit)} nextButtonTitle={t('checkin.additionalInformation.finishButton')} />
        </S.ContainerAdditionalInfo>
    )
}